import { FC } from 'react';
import { Grid2 as Grid, IconButton, Typography } from '@mui/material';
import { FiltersLayout } from 'framework/list';
import { PlusIcon } from 'framework/ui/mui-builder';
import { useAssumptionActions } from '../CreateAndUpdateAssumption/AssumptionActionsProvider';
import { ASSUMPTION_STATUS_OPTIONS } from '../CreateAndUpdateAssumption/constants';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  StatusFilter,
  useProjectSecurityContext,
} from 'domain/shared/newProject';

const AssumptionsListHeader: FC = () => {
  const { openCreate } = useAssumptionActions();
  const { isAccessGranted } = useProjectSecurityContext();
  const canCreate = isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.MANAGE);

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      pl={2}
      gap={{ xs: 4, md: 16 }}
    >
      <Grid size={2}>
        <Typography variant="h4" color="primary" noWrap>
          Assumptions
        </Typography>
      </Grid>
      <Grid
        size="auto"
        alignItems="center"
        sx={{
          '.add-filter-button__wrapper': { mb: 0 },
          '.filter-item-wrapper': { mb: 0 },
          '.filters-reset-btn': { mb: 0 },
        }}
      >
        <FiltersLayout>
          <StatusFilter
            source="status"
            label="Status"
            options={ASSUMPTION_STATUS_OPTIONS}
            data-testid="assumption-status-filter"
          />
        </FiltersLayout>
      </Grid>
      <Grid size="grow" />
      <Grid size="auto" display="flex" alignItems="center" mr={0.7}>
        {canCreate && (
          <IconButton sx={{ p: 0, ml: 1 }} onClick={openCreate}>
            <PlusIcon />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default AssumptionsListHeader;
